import React, { Component, type ComponentType } from 'react'

export default (fetchData: (...args: any[]) => Promise<any>, timeout = 10) =>
  <P extends object>(DecoratedComponent: ComponentType<P>) => {
    return class FetchData extends Component<P, any> {
      static displayName = 'FetchData'

      async componentDidMount() {
        this._isMounted = true
        const propsToPass = await this.callFetchData()
        if (this._isMounted) this.setState(propsToPass)
      }

      componentWillUnmount() {
        this._isMounted = false
      }

      _isMounted = false

      callFetchData = () =>
        new Promise(resolve => {
          setTimeout(async () => {
            resolve(await fetchData(this.props))
          }, timeout)
        })

      render() {
        return <DecoratedComponent {...this.props} {...this.state} />
      }
    }
  }
